import { useNavigate } from 'react-router-dom'
import { AppLayout } from '../components/AppLayout'
import { SourcingStatusBoard } from '../components/sourcing/SourcingStatusBoard'

/**
 * /account/sourcing — Profile → "My sourcing": the buyer's monitoring surface
 * for agentic sourcing (docs/ASKA-PLUS-AGENTIC-SOURCING.md §2.2). NOT a
 * top-level tab (that's `/sourcing`, the limit-order desk) — this is the
 * read-mostly status board reached from the Profile hub. Body is the shared
 * <SourcingStatusBoard/> (identical on mobile).
 */
export function AccountSourcing() {
  const navigate = useNavigate()
  return (
    <AppLayout>
      <div className="mx-auto max-w-3xl px-4 sm:px-6 py-8 sm:py-10">
        <button
          type="button"
          onClick={() => navigate('/account/profile')}
          className="mb-6 inline-flex items-center gap-1.5 text-[13px] font-medium text-soft hover:text-ink"
        >
          <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><path d="m15 18-6-6 6-6" /></svg>
          Account
        </button>
        <p className="text-[11px] font-semibold uppercase tracking-[0.18em] text-gold">Aska+</p>
        <h1 className="mt-1 font-serif text-3xl font-bold tracking-tight text-ink">My sourcing</h1>
        <p className="mt-1 text-sm text-soft">Track what your sourcing agent is working on — and the stones you’ve queued.</p>
        <div className="mt-8">
          <SourcingStatusBoard />
        </div>
      </div>
    </AppLayout>
  )
}
